import React, {Suspense} from "react"
import TermImage from "./term_image"
import ErrorBoundary, {LoadingErrorFallback} from "../error_boundary"

const LoadingTermImage = ({image}) => (
  <ErrorBoundary fallback={<LoadingErrorFallback />}>
    <Suspense fallback={<div className="spinner"></div>}>
      <TermImage image={image} />
    </Suspense>
  </ErrorBoundary>
)

export default LoadingTermImage
